var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.small)?_c('h1',{class:{
        'display-1': _vm.$vuetify.breakpoint.mdAndDown,
        'display-2': !_vm.$vuetify.breakpoint.mdAndDown,
        'font-weight-bold': true,
         'text-uppercase': true,
         'text-center': true,
         'mx-auto': true,
         'my-10': true,
         }},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('h2',{class:{
        'font-weight-bold': true,
         'text-uppercase': true,
         'text-center': true,
         'mx-auto': true,
         'my-10': true,
         }},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }